const HARD_RELOAD_PENDING_KEY = 'absticare:hard-reload-after-sw-update';
const HARD_RELOAD_QUERY_PARAM = '__absticareHardReload';

function buildHardReloadUrl(): string {
  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set(HARD_RELOAD_QUERY_PARAM, Date.now().toString());
  return nextUrl.toString();
}

async function clearRuntimeCaches(): Promise<void> {
  if (typeof window === 'undefined' || !('caches' in window)) {
    return;
  }

  const cacheNames = await window.caches.keys();
  await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
}

export async function performHardReload(): Promise<void> {
  try {
    // Ein echtes STRG+F5 ist per JavaScript nicht direkt auslösbar.
    // Diese Kombination aus Cache-Löschung und URL-Nonce emuliert das Verhalten zuverlässig.
    await clearRuntimeCaches();
  } catch (error) {
    console.warn('Löschen der Browser-Caches für Hard-Reload fehlgeschlagen', error);
  }

  window.location.replace(buildHardReloadUrl());
}

export function markHardReloadAfterServiceWorkerUpdate(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(HARD_RELOAD_PENDING_KEY, 'true');
  } catch (error) {
    console.warn('Hard-Reload-Markierung konnte nicht in sessionStorage geschrieben werden', error);
  }
}

export function consumeHardReloadAfterServiceWorkerUpdate(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const shouldHardReload = window.sessionStorage.getItem(HARD_RELOAD_PENDING_KEY) === 'true';
    if (shouldHardReload) {
      window.sessionStorage.removeItem(HARD_RELOAD_PENDING_KEY);
    }

    return shouldHardReload;
  } catch (error) {
    console.warn('Hard-Reload-Markierung konnte nicht aus sessionStorage gelesen werden', error);
    return false;
  }
}
